var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.swiperItems.length > 0)?_c('ui-photo-swipe',{attrs:{"options":_vm.swiperOptions,"items":_vm.swiperItems},on:{"close":_vm.hidePhotoSwipe}}):_vm._e(),_c('ui-add-to-list'),_c('ui-buy'),_c('ui-ccil')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }